<template>
    <div class="ReportDetails" v-show="isShow">
        <!--上面部分-->
        <div class="details_top_wrap">
            <div class="top_info_wrap">
                <img class="top_bannerImg" :src="detailsData.coveratturl" alt="">
                <div class="top_right_wrap" v-if="isshowdet">
                    <div class="gary_box">
                        <div class="title">{{detailsData.title}}</div>
                        <p><img :src="detTime" alt=""> {{detailsData.begintime}}-{{detailsData.endtime}}</p>
                        <p class="address" @click="goMap(detailsData.address)"><img :src="detAddr" alt=""> {{detailsData.address}}</p>
                        <p><img :src="detPerson" alt="">
                            <span>{{detailsData.ticketcount==0?'人数不限':'限'+detailsData.ticketcount+'人'}}</span>
                            <span v-if="detailsData.isdisplayenrollcount==1"><b class="rowline">|</b>已报名{{detailsData.currentenrollcount}}人</span>
                        </p>
                    </div>
                    <div class="top_right_bottom">
                        <div class="button_left">
                            <el-button type="danger" v-if="detailsData.status!=30" @click="openSelect">立即参与</el-button>
                            <el-button type="info" :disabled="true" v-else>活动已结束</el-button>
                        </div>
                        <div class="operation_right">
                            <span class="cursor_class"><img :src="require('@/common/images/report/see.png')" alt="">浏览量 {{detailsData.viewcount}}</span>
                            <span class="line">｜</span>
                            <el-popover
                                    placement="top"
                                    width="106"
                                    trigger="hover">
                                <div class="icon_popover_box">
                                    <div id="qrcodeUrl"></div>
                                    <p>扫码手机分享</p>
                                </div>
                                <span class="icon_box cursor_class" slot="reference">
                                    <img :src="require('@/common/images/other/share_icon.png')" alt="">
                                    <span>分享</span>
                                </span>
                            </el-popover>
                            <span class="line">｜</span>
                            <span class="cursor_class" @click="collectionClick(detailsData.isfavorite)"  :class="detailsData.isfavorite === 1 ? 'is_enshrine':'enshrine'">
                            <img  :src="detailsData.isfavorite === 1 ? require('@/common/images/other/y_enshrine.png') : require('@/common/images/other/n_enshrine.png')" alt="">{{detailsData.isfavorite === 0 ? '添加' : '取消'}}收藏
                        </span>
                        </div>
                    </div>
                    <SelectTicket ref="selectTicket" @openDet="_openDet" :orderinfo="orderinfo"></SelectTicket>
                </div>
            </div>
        </div>
        <!--下面部分-->
        <div class="details_bottom_wrap">
            <!--左侧-->
            <div class="tab_left_box">
                <!--活动详情-->
                <div class="tab_item tab_title">
                    <span class="bold">活动详情</span>
                    <span class="r_title" @click="handleOpen"><img :src="isopen?detUp:detUnder" alt="">{{isopen?'收起':'展开'}}</span>
                </div>
                <div class="tab_main activeDet" v-html="detailsData.eventdesp" v-if="isopen"></div>
                <!--报名人员-->
                <div v-if="detailsData.isdisplayenrollinfo==1">
                    <div class="tab_item">报名人员</div>
                    <div class="tab_main sign_box">
                        <template v-if="signList.length>0">
                            <div class="signList" v-for="(item,index) in signList" :key="index">
                                <img :src="item.customericonurl" alt="">
                                <p>{{item.customername}}</p>
                            </div>
                        </template>
                        <div class="noData_wrap" v-else>
                            <img :src="noData" alt="">
                            <p>当前暂无报名人员，快去参与报名吧！</p>
                        </div>
                    </div>
                </div>
                <!--发表评论-->
                <div class="tab_item">发表评论</div>
                <div class="submit_wrap">
                    <div class="tab_main submitComm">
                        <el-input type="textarea" placeholder="您有任何问题可在这里咨询…"  v-model="content" maxlength="300" show-word-limit></el-input>
                    </div>
                    <el-button type="primary" @click="submitInfo">发表评论</el-button>
                </div>
                <!--评论区-->
                <div class="tab_item">评论区</div>
                <div class="tab_main">
                    <div class="report_comment_wrap" data-mcs-theme="dark">
                        <div class="comment_list" v-if="commentList.length>0">
                            <div class="comment_list_item" v-for="(item,index) in commentList" :key="index">
                                <div class="comment_info">
                                    <img :src="item.userpic" alt="">
                                    <span class="name">{{item.username}}</span>
                                    <span class="date">{{item.commenttime}}</span>
                                </div>
                                <div class="comment_main">{{item.content}}</div>
                                <div class="reply" v-if="item.replylist.length>0">
                                    <div class="replyBox" v-for="(item2,index) in item.replylist" :key="index">
                                        <b>主办方回复：</b>{{item2.replycontent}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="noData_wrap" v-else>
                            <img :src="noData" alt="">
                            <p>当前暂无评论 </p>
                        </div>
                    </div>
                    <div v-show="commentList.length > 0" class="page_box evaluate_page_box">
                        <el-pagination background layout="prev, pager, next" :page-size="5" :total="commentPageTotal"  @current-change="pfPage"></el-pagination>
                    </div>
                </div>

            </div>
            <!--右侧-->
            <div class="tab_right_box">
                <!--活动主办方-->
                <div class="tab_item">活动主办方</div>
                <div class="tab_main report_list" @click="goHost(hostinfo.hostid)">
                    <div class="report_list_item sponsor">
                        <span class="reportBg">
                            <img :src="hostinfo.hostpic" alt=""><b>{{hostinfo.hostname}}</b>
                        </span>
                        <div class="hostdesp_box"  v-if="hostinfo.hostdesp">
                            <span class="hostline"></span>
                            <span class="hostdesp">{{hostinfo.hostdesp}}</span>
                        </div>
                    </div>
                </div>
                <!--活动客服-->
                <template v-if="detailsData.qrcodeatturlid">
                    <div class="tab_item">活动客服</div>
                    <div class="tab_main serve_box">
                        <img :src="detailsData.qrcodeatturlid" alt="">
                        <div>
                            <p class="se_desp">{{detailsData.servicebuttontext}}</p>
                            <p class="subDesp">扫一扫添加微信客服</p>
                        </div>
                    </div>
                </template>

                <!--您还感兴趣的-->
                <div class="tab_item">您还感兴趣的</div>
                <div class="tab_main report_list">
                    <div class="report_list_item" v-for="(item,index) in eventList" :key="index" @click="likeClick(item)">
                        <span class="reportBg"><img :src="item.eventlogo" alt=""></span>
                        <span>{{item.title}}</span>
                        <span class="line"></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <IndexSilder></IndexSilder> -->
    </div>
</template>
<script>
    import {getEventDetail,getCommentList,getRecommendEvent,operateEventFollowInfo,uploadCommentInfo} from 'api/hdApi'
    import {mapGetters,mapActions} from 'vuex'
    // import IndexSilder from '@/views/hdPc/components/indexSilder'
    import SelectTicket from '@/views/hdPc/components/selectTicket'
    import $ from 'jquery'
    import QRCode  from "qrcodejs2"
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
    export default {
        name: "HdDetails",
        data() {
            return {
                isShow:false,
                content:'', //评价内容
                isopen:true,
                isshowdet:true,
                coverurl:'http://cdn.img.capwhale.com/kmc/content/20190821/1bcb1cd98d364ac191c1038f072701e2.jpg',
                detailsData:{}, //活动详情
                detTime:require('@/common/images/hd/detTime.png'),
                detAddr:require('@/common/images/hd/detAddr.png'),
                detPerson:require('@/common/images/hd/detPerson.png'),
                detUnder:require('@/common/images/hd/detUnder.png'),
                detUp:require('@/common/images/hd/detUp.png'),
                noData:require('@/common/images/hd/noData.png'),
                eventList:[],  //相关活动列表
                signList:[], //报名人员
                hostinfo:{}, //主办方信息
                orderinfo:{}, //订单信息
                commentList:[], //评论列表
                commentPageTotal: 0, // 评论全部页码
                textarea:'',
            }
        },
        created() {
            if(this.domainInfo.isMobile){
                this.$router.push({
                    name: 'ActivityDetail',
                    query: {'eventid': this.$route.query.eventid}
                })
            }
        },
        mounted() {
            this._getInfo();
            this._getCommentList(1);
            this._getActiveList();
            this.qRCode()
        },
        methods: {
            //获取活动详情
            _getInfo(){
                this.setLoading(true);
                let param={
                    eventid:this.$route.query.eventid
                };
                getEventDetail({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false)
                        this.isShow=true
                        this.detailsData=data.data.eventinfo
                        this.orderinfo=data.data.orderinfo
                        this.signList=data.data.enrolleventorderitem
                        this.hostinfo=data.data.eventinfo.hostinfo
                        document.title = data.data.eventinfo.title
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //跳转至地图
            goMap(address){
                let mapUrl='https://ditu.amap.com/search?query='+address;
                window.open(mapUrl)
                // window.location.href=mapUrl
            },
            // 感兴趣的点击
            likeClick(data){
                if(data.enrolleventsource==2){ //第三方
                    window.open(data.enrolllinkurl)
                }else{
                    this.$router.push({name: 'HdDetails', query: {'eventid': data.eventid}})
                }
            },
            // 分享二维码生成
            qRCode() {
                new QRCode('qrcodeUrl', {
                    width: 100,
                    height: 100, // 高度
                    text: window.location.origin+'/m/mkaa/activityDetail?eventid='+this.$route.query.eventid,   // 二维码内容
                })
            },
            //发表评论
            submitInfo(){
                if(this.user.isLogin===true){
                    this.setLoading(true);
                    let params = {
                        eventid:this.$route.query.eventid,
                        content:this.content,
                    };
                    uploadCommentInfo({
                        data: Object.assign({}, params),
                        success: data => {
                            console.log(data)
                            this.setLoading(false);
                            this.$message.success('提交成功');
                            this.content='';
                            this._getCommentList(1)
                        },
                        error: data => {
                            this.$message.error(data.msg)
                        }
                    });
                }else{
                    this.setLoginPop(true)
                }
            },
            // 获取评论列表
            _getCommentList(val){
                this.setLoading(true);
                let params = {
                    eventid:this.$route.query.eventid,
                    page:val,
                    pageSize:5
                };
                getCommentList({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.commentList = data.data.content;
                        this.commentPageTotal = data.data.pageinfo.rowCount
                        $('.report_comment_wrap').mCustomScrollbar({
                            autoHideScrollbar:true
                        });
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 评论分页
            pfPage(){
                let clickPage = $(".evaluate_page_box .el-pagination .active").html()
                this._getCommentList(clickPage)
            },
            //获取推荐活动列表
            _getActiveList(){
                this.setLoading(true);
                let param={
                    eventid:this.$route.query.eventid
                };
                getRecommendEvent({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false)
                        this.eventList=data.data
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 收藏活动
            collectionClick(val) {
                if(this.user.isLogin===true){
                    this.setLoading(true);
                    let params = {
                        eventid : this.$route.query.eventid,
                        optype: val === 1 ? 2 : 1,
                    }
                    operateEventFollowInfo({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false)
                            if (data.code === '000') {
                                if (val === 1) {
                                    this.detailsData.isfavorite = 0
                                    this.$message.success('已取消收藏')
                                } else {
                                    this.detailsData.isfavorite = 1
                                    this.$message.success('收藏成功')
                                }
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                }else{
                    this.setLoginPop(true)
                }
            },
            //是否展开活动详情
            handleOpen(){
                this.isopen = !this.isopen
            },
            //打开选择票种
            openSelect(){
                if(this.user.isLogin===true){
                    this.isshowdet=true;
                    this.$refs.selectTicket.open(this.$route.query.eventid);
                }else{
                    this.setLoginPop(true)
                }
            },
            //显示右侧参与
            _openDet(){
                this.isshowdet=true
            },
            //跳转至主办方
            goHost(id){
                this.$router.push({name: 'HdHost',query:{hostid:id}})
            },
            // 回到顶部
            goTop() {
                $("html,body").animate({
                    scrollTop: 0
                }, 400)
            },
            ...mapActions([
                'setLoading',
                'setLoginPop',
                'setUser'
            ])
        },
        watch: {
            $route: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.detailsData = {}
                    this.commentList=[]
                    this._getInfo()
                    this._getCommentList(1)
                    this._getActiveList()
                    this.goTop()
                }
            },
            user: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.detailsData = {}
                    this.commentList=[]
                    this._getInfo()
                    this._getCommentList(1)
                    this._getActiveList()
                    this.goTop()
                }
            }
        },
        computed: {
            ...mapGetters(['loginPop', 'user','domainInfo'])
        },
        components: {
            // IndexSilder,
            SelectTicket
        }
    }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .ReportDetails{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        color: #333;
        height: 100%;
        .details_top_wrap{
            padding: 0px 0 30px 0;
            width: 1200px;
            box-sizing: border-box;
            margin: 0 auto;
            .top_info_wrap{
                display: flex;
                justify-content: space-between;
                .top_bannerImg{
                    width:450px;
                    min-width: 450px;
                    height:250px;
                    border-radius: 4px;
                }
                .top_right_wrap{
                    margin-left:20px;
                    width:100%;
                    position: relative;
                    .gary_box{
                        height:auto;
                        min-height: 200px;
                        padding-bottom: 8px;
                        .title{
                            font-size: 20px;
                            line-height: 32px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            color: #333;
                            margin-bottom: 16px;
                        }
                        p{
                            line-height: 20px;
                            margin-bottom: 16px;
                            display: flex;
                            align-items: center;
                            color: #666;
                            img{
                                margin-right: 10px;
                            }
                            .rowline{
                                margin: 0 5px;
                                color: #e5e5e5;
                            }
                        }
                        p:last-child{
                            padding-bottom: 0;
                            margin-bottom: 10px;
                        }
                        .address{
                            color: #1464C8;
                            cursor: pointer;
                        }
                    }
                    .top_right_bottom{
                        display: flex;
                        justify-content: space-between;
                        .button_left{
                            display: flex;
                            .el-button--danger{
                                background: rgba(255,71,71,1);
                                border-color: rgba(255,71,71,1);
                            }
                            .el-button--danger:focus, .el-button--danger:hover{
                                opacity: 0.8;
                            }
                            .el-button--info.is-disabled{
                                background-color: #E5E5E5;
                                border-color: #E5E5E5;
                                color: #999;
                            }
                            .el-button {
                                width: 160px;
                                margin-right: 20px;
                                padding: 8px;
                                border-radius: 24px;
                                &>span {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    font-size: 16px;
                                    line-height: 22px;
                                    &>img {
                                        width: 18px;
                                        height: 18px;
                                        margin-right: 8px;
                                    }
                                }
                            }
                        }
                        .operation_right{
                            display: flex;
                            align-items: center;
                            span {
                                color: #999;
                                white-space: nowrap;
                            }
                            .line {
                                color: #e5e5e5;
                                margin: 0 10px;
                            }
                            .cursor_class {
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                & > img {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 4px;
                                }
                            }
                            .is_enshrine{
                                color: #409EFF;
                            }
                        }
                    }
                }
            }
        }
        .details_bottom_wrap{
            height: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
            .tab_left_box,.tab_right_box{
                .tab_item{
                    font-size: 16px;
                    color: #333;
                    margin-bottom: 20px;
                    font-weight: bold;
                }
                .tab_main{
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.1);
                    border-radius:6px;
                    padding: 20px 0;
                    margin-bottom: 20px;
                    .noData_wrap{
                        text-align: center;
                        width: 100%;
                        font-size: 12px;
                        color: #999;
                        padding: 20px 0;
                        img{
                            margin: 0 auto 12px;
                        }
                    }
                    .evaluate_page_box{
                        text-align: center;
                        padding-top: 15px;
                    }
                }
            }
            /*左侧选项卡*/
            .tab_left_box {
                width: 100%;
                .tab_title{
                    display: flex;
                    justify-content: space-between;
                    .bold{
                        font-weight: bold;
                    }
                    .r_title{
                        font-size: 12px;
                        color: #666;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        img{
                            margin-right: 5px;
                        }
                    }
                }
                .activeDet{
                    padding: 20px;
                    width: 100%;
                    box-sizing: border-box;
                    * {
                        line-height: 30px;
                    }
                    img, video {
                        width: 100%;
                        height: auto;
                    }
                }
                .sign_box{
                    display: flex;
                    padding: 20px;
                    text-align: center;
                    .signList{
                        margin-right: 39px;
                        img{
                            width: 72px;
                            height: 72px;
                            border-radius: 50%;
                            margin-bottom: 15px;
                        }
                    }
                    .signList:last-child{
                        margin-right: 0;
                    }
                }
                .submit_wrap{
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 20px;
                    .submitComm{
                        padding: 10px 0;
                        margin-bottom: 10px;
                        .el-textarea__inner{
                            height: 130px;
                            resize: none;
                            padding: 0 20px;
                            border: none;
                        }
                    }
                    .el-button{
                        width: 100px;
                        display: flex;
                        align-self: flex-end;
                        background-color: rgba(20,100,200,1);
                        border-color: rgba(20,100,200,1);
                    }
                    .el-button--primary:focus, .el-button--primary:hover{
                        opacity: 0.8;
                    }
                }
                .report_comment_wrap{
                    max-height: 570px;
                    overflow-y: auto;
                    .title{
                        font-size: 16px;
                        margin: 30px 0;
                    }
                    .comment_box{
                        .el-textarea__inner{
                            height: 150px;
                            padding: 10px;
                            resize: none;
                        }
                        .comment_tips{
                            height: 50px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            background:rgba(229,229,229,1);
                            .left_text{
                                min-width: 790px;
                                display: flex;
                                justify-content: space-between;
                                padding: 0 10px;
                                color: #666;
                            }
                            .el-button {
                                border-radius: 0;
                                height: 50px;
                                &>span {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    &>img {
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 5px;
                                    }
                                }
                            }
                        }
                    }
                    .comment_list{
                        /*max-height: 570px;*/
                        /*overflow-y: auto;*/
                        padding: 0 20px;
                        .comment_list_item{
                            border-bottom: 1px solid #E5E5E5;
                            margin-top: 20px;
                            .comment_info{
                                display: flex;
                                align-items: center;
                                img{
                                    width: 52px;
                                    height: 52px;
                                    border-radius: 50%;
                                    background: gray;
                                    display: inline-block;
                                }
                                span{
                                    margin-left: 20px;
                                    font-size: 16px;
                                    color: #333;
                                }
                                .date{
                                    font-size: 14px;
                                    color: #999;
                                }
                            }
                            .comment_main{
                                margin-left: 70px;
                                line-height: 22px;
                                padding-bottom: 15px;
                                word-break: break-all;
                            }
                            .reply{
                                margin-left: 70px;
                                padding: 12px;
                                background:rgba(248,248,248,1);
                                margin-bottom: 15px;
                                line-height: 25px;
                                .replyBox{
                                    margin-bottom: 5px;
                                    b{
                                        color: #1464C8;
                                    }
                                }
                                .replyBox:last-child{
                                    margin-bottom: 0;
                                }
                            }
                        }
                        .comment_list_item:first-child{
                            margin-top: 0;
                        }
                    }
                    .page_box {
                        display: flex;
                        justify-content: center;
                        padding-top: 20px;
                    }
                }
            }
            /*右侧列表*/
            .tab_right_box{
                min-width: 285px;
                width: 285px;
                margin-left: 20px;
                .report_list{
                    border-top: none;
                    .report_list_item:last-child .line{
                        display: none;
                    }
                    .report_list_item{
                        padding: 0 20px;
                        cursor: pointer;
                        .reportBg{
                            margin-bottom: 12px;
                            img{
                                width:260px;
                                height:147px;
                            }
                        }
                        span{
                            line-height: 22px;
                            display: inline-block;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                            overflow: hidden;
                        }
                        .line{
                            width: 100%;
                            height: 1px;
                            background: #E5E5E5;
                            margin: 20px 0;
                        }
                    }
                    .sponsor{
                        .reportBg{
                            display: flex;
                            align-items: center;
                            margin-bottom: 0;
                            img{
                                width:72px;
                                height:72px;
                                border-radius: 50%;
                                margin-right: 10px;
                            }
                            b{
                                font-size: 16px;
                            }
                        }
                        .hostdesp_box{
                            padding-top: 10px;
                            color: #999;
                            .hostline{
                                width: 100%;
                                height: 1px;
                                background: #e5e5e5;
                                margin: 12px 0;
                                display: inline-block;
                            }
                        }
                    }
                }
                .serve_box{
                    display: flex;
                    align-items: center;
                    padding: 20px;
                    img{
                        width: 100px;
                        height: 100px;
                        margin-right: 10px;
                    }
                    .se_desp{
                        line-height: 20px;
                    }
                    .subDesp{
                        margin-top: 12px;
                        font-size: 12px;
                        color: #999;
                    }
                }
            }
        }
    }
    .icon_popover_box {
        #qrcodeUrl{
            margin-bottom: 6px;
        }
    }
    /*滚动条样式*/
    .mCSB_scrollTools .mCSB_dragger{
        height: 60px!important;
    }
    .mCS-dark.mCSB_scrollTools .mCSB_draggerRail{
        background-color: #fff;
    }
    .mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{
        background-color: #ccc !important;
    }
</style>